import competenciesHeroArrow from '@/assets/illustrations/competenciesHeroArrow.png';
import { useAmelioTranslations } from '@/hooks';

// Stacked-layers glyph from the reference prototype (performance-ai5).
const StackedLayersIcon = () => (
    <svg
        className={'ch-iconsvg text-primary'}
        viewBox={'0 0 36 36'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={1.8}
        strokeMiterlimit={10}
    >
        <path
            d={
                'M30 5.25H8.25C7.8 5.25 7.35 5.4 7.05 5.85L4.8 8.85C4.05 9.9 4.8 11.25 6 11.25H27.75C28.2 11.25 28.65 11.1 28.95 10.65L31.2 7.65C31.95 6.6 31.2 5.25 30 5.25Z'
            }
        />

        <path
            d={
                'M6 15H27.75C28.2 15 28.65 15.15 28.95 15.6L31.2 18.6C31.95 19.65 31.2 21 30 21H8.25C7.8 21 7.35 20.85 7.05 20.4L4.8 17.4C4.05 16.35 4.8 15 6 15Z'
            }
        />

        <path
            d={
                'M30 24.75H8.25C7.8 24.75 7.35 24.9 7.05 25.35L4.8 28.35C4.05 29.4 4.8 30.75 6 30.75H27.75C28.2 30.75 28.65 30.6 28.95 30.15L31.2 27.15C31.95 26.1 31.2 24.75 30 24.75Z'
            }
        />
    </svg>
);

export const CompetenciesHero = () => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'relative z-20 flex items-center gap-6'}>
            <div
                style={{ maxWidth: '590px' }}
                className={
                    'ch-card flex w-full items-center gap-3 rounded-2xl border border-white bg-white/45 backdrop-blur-md'
                }
            >
                <div
                    className={
                        'ch-icon flex flex-shrink-0 items-center justify-center rounded-full bg-teal-50/70'
                    }
                >
                    <StackedLayersIcon />
                </div>

                <div className={'flex-1'}>
                    <h1 className={'ch-title text-navy font-medium'}>{t('competencies.title')}</h1>

                    <p className={'text-navy text-sm leading-normal'}>
                        {t('competencies.subtitle')}
                    </p>
                </div>
            </div>

            <div
                className={'competencies-hero-arrow pointer-events-none relative flex-shrink-0'}
                style={{ transform: 'translate(-20px, 70px) scale(0.9)' }}
            >
                <img
                    src={competenciesHeroArrow}
                    alt={''}
                    aria-hidden={'true'}
                    className={'h-[234px] w-[308px]'}
                />
            </div>
        </div>
    );
};
